import { textStyles } from '../textStyles';
export const Tooltip = {
    baseStyle() {
        return {
            ...textStyles.body2,
            maxW: '100vw',
            bg: 'brand.secondary-dark-blue',
            color: 'brand.white',
            rounded: '8px',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: 'brand.gray-scale-border-10',
            px: '12px',
            py: '8px',
            '& .chakra-tooltip__arrow': {
                bg: 'brand.secondary-dark-blue!important',
            },
        };
    },
    variants: {},
    sizes: {},
    defaultProps: {},
};
